/**
 * Do not edit directly
 */

export default "PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0ibTEyIDIuNWE5LjUgOS41IDAgMSAxIC05LjUgOS41IDkuNTEgOS41MSAwIDAgMSA5LjUtOS41bTAtMS41YTExIDExIDAgMSAwIDExIDExIDExIDExIDAgMCAwIC0xMS0xMXoiLz48cGF0aCBkPSJtMTAuNSA4LjggNC44IDMuMi00LjggMy4yem0tMS41LTIuOHYxMmw5LTZ6Ii8+PC9zdmc+";